import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { APP_STATUS_LABEL, APP_STATUS_OPTIONS } from '../../../../../Consts/app-status.const';
import { UserFilters } from '../../../Interfaces/user-filters.interface';

@Component({
  selector: 'av-user-filters',
  standalone: true,
  imports: [ReactiveFormsModule, MatIconModule, TranslateModule],
  templateUrl: './user-filters.component.html',
  styleUrl: './user-filters.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class UserFiltersComponent {
  private readonly _formBuilder = inject(FormBuilder);

  readonly value = input.required<UserFilters>();
  readonly disabled = input<boolean>(false);

  readonly filtersChange = output<UserFilters>();

  readonly statusOptions = APP_STATUS_OPTIONS;
  readonly statusLabelKeys = APP_STATUS_LABEL;

  readonly formGroup: FormGroup = this._formBuilder.group({
    search: [''],
    app_status: [''],
  });

  constructor() {
    this._registerValueSync();
  }

  submit(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this.filtersChange.emit({
      search: String(this.formGroup.value.search ?? '').trim(),
      app_status: String(this.formGroup.value.app_status ?? ''),
      organization_id: this.value().organization_id,
    });
  }

  reset(): void {
    this.formGroup.reset({ search: '', app_status: '' });
    this.submit();
  }

  private _registerValueSync(): void {
    effect(() => {
      const filters = this.value();

      this._patchForm(filters);
    });
  }

  private _patchForm(filters: UserFilters): void {
    this.formGroup.patchValue(
      { search: filters.search, app_status: filters.app_status },
      { emitEvent: false },
    );
  }
}
